module.exports = __webpack_public_path__ + "static/media/textel-1200px-logo.a437283b.png";